module.exports = __webpack_public_path__ + "static/media/fac12.c5c588e2.jpg";